var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipsEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 100,
    viewBox: "0 0 196 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.071 38.3505L123.506 58.8778L127 75.4887L124.984 79H84.5308H76.0638L68 40.7814L71.4943 37H111.813L119.071 38.3505Z",
    fill: "url(#paint0_linear_10636_47794)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.535 48H145.465C144.656 48 144 48.6715 144 49.5C144 50.3285 144.655 51 145.465 51H156.535C157.344 51 158 50.3285 158 49.5C158 48.6715 157.345 48 156.535 48Z",
    fill: "url(#paint1_linear_10636_47794)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.873 74.7735L151.664 79.8383C151.898 79.9488 152.149 80 152.394 80C152.977 80 153.539 79.7093 153.823 79.2026C154.227 78.482 153.917 77.5966 153.127 77.227L142.336 72.1623C141.551 71.7918 140.581 72.0774 140.177 72.798C139.773 73.5186 140.083 74.404 140.873 74.7735V74.7735Z",
    fill: "url(#paint2_linear_10636_47794)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.606 28C141.852 28 142.103 27.9488 142.336 27.8383L153.127 22.7744C153.917 22.4049 154.227 21.5197 153.823 20.7992C153.419 20.0787 152.451 19.7901 151.664 20.1636L140.873 25.2275C140.083 25.597 139.773 26.4823 140.177 27.2027C140.461 27.7093 141.023 28 141.606 28V28Z",
    fill: "url(#paint3_linear_10636_47794)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5695 51H50.4305C51.2973 51 52 50.3285 52 49.5C52 48.6715 51.2984 48 50.4305 48H38.5695C37.7027 48 37 48.6715 37 49.5C37 50.3285 37.7016 51 38.5695 51Z",
    fill: "url(#paint4_linear_10636_47794)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8355 27.2027C55.2106 26.4821 54.9228 25.5967 54.1892 25.2272L44.169 20.1628C43.4405 19.7912 42.5386 20.0778 42.1645 20.7984C41.7894 21.519 42.0772 22.4043 42.8108 22.7738L52.831 27.8383C53.0482 27.9488 53.281 28 53.5085 28C54.0499 28 54.5716 27.7093 54.8355 27.2027V27.2027Z",
    fill: "url(#paint5_linear_10636_47794)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1645 79.2027C42.4274 79.7093 42.95 80 43.4914 80C43.72 80 43.9528 79.9488 44.169 79.8383L54.1892 74.7742C54.9228 74.4048 55.2106 73.5195 54.8355 72.799C54.4604 72.0774 53.5595 71.7908 52.831 72.1634L42.8108 77.2274C42.0772 77.5969 41.7894 78.4812 42.1645 79.2027V79.2027Z",
    fill: "url(#paint6_linear_10636_47794)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.182 19.0022H111.008C107.21 19.0022 104.038 21.7398 103.334 25.3658H79.2104C75.9127 25.3658 73.2307 28.0643 73.2307 31.3807V34.8842C71.395 34.9117 69.6685 35.7252 68.485 37.141C67.2794 38.5822 66.7732 40.4723 67.0946 42.3267L73.0753 76.9047C73.4881 79.2777 75.5244 81 77.9189 81H123.085C124.54 81 125.909 80.3576 126.846 79.2377C127.473 78.4875 127.832 77.5768 127.94 76.6195C127.96 76.5202 128 76.4283 128 76.3237V26.8639C128 22.5279 124.493 19 120.184 19L120.182 19.0022ZM79.2099 28.3952H104.696C105.528 28.3952 106.202 27.7031 106.202 26.8663C106.202 24.2006 108.357 22.0315 111.008 22.0315H120.183C122.832 22.0315 124.987 24.1996 124.987 26.8663V59.8539L121.216 40.146C120.688 37.0915 118.069 34.8739 114.987 34.8739H76.243V31.382C76.243 29.7359 77.5746 28.3962 79.2108 28.3962L79.2099 28.3952ZM124.54 77.2896C124.177 77.7239 123.646 77.9722 123.084 77.9722L77.9172 77.9732C76.9899 77.9732 76.2002 77.3055 76.0416 76.3863L70.0608 41.8082C69.8917 40.8362 70.1574 39.8473 70.7886 39.0918C71.4198 38.3364 72.3439 37.9043 73.3248 37.9043H114.985C116.599 37.9043 117.971 39.0654 118.252 40.6926L124.957 75.7277C125.054 76.2856 124.9 76.8551 124.539 77.2883L124.54 77.2896Z",
    fill: "url(#paint7_linear_10636_47794)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10636_47794",
    x1: 127,
    y1: 37,
    x2: 87.3142,
    y2: 92.7491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10636_47794",
    x1: 158,
    y1: 48,
    x2: 156.771,
    y2: 53.7366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D95C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D9FB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10636_47794",
    x1: 154,
    y1: 72,
    x2: 147.108,
    y2: 84.0615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D95C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D9FB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10636_47794",
    x1: 154,
    y1: 20,
    x2: 147.108,
    y2: 32.0615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D95C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D9FB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10636_47794",
    x1: 52,
    y1: 48,
    x2: 50.8462,
    y2: 53.7692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D95C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D9FB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10636_47794",
    x1: 55,
    y1: 20,
    x2: 47.8584,
    y2: 31.6052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D95C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D9FB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10636_47794",
    x1: 55,
    y1: 72,
    x2: 47.8584,
    y2: 83.6052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D95C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D9FB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10636_47794",
    x1: 128,
    y1: 19,
    x2: 66.0084,
    y2: 79.9919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipsEmpty);
export default __webpack_public_path__ + "static/media/clips-empty.654e32bcc9486a024d42564e1a15991b.svg";
export { ForwardRef as ReactComponent };